/* eslint-disable */
import {
  MenuItemsType,
  SwapIcon,
  SwapFillIcon,
  EarnFillIcon,
  EarnIcon,
  TrophyIcon,
  TrophyFillIcon,
  NftIcon,
  NftFillIcon,
  MoreIcon,
  ArrowUpDownIcon,
} from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { nftsBaseUrl } from 'views/Nft/market/constants'
import { perpLangMap } from 'utils/getPerpetualLanguageCode'
import { perpTheme } from 'utils/getPerpetualTheme'
import { DropdownMenuItems } from '@pancakeswap/uikit/src/components/DropdownMenu/types'
import { ChainId } from '@pancakeswap/sdk'
import { DropdownMenuItemType } from '@pancakeswap/uikit/src/components/DropdownMenu/types'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean } & {
  items?: ConfigMenuDropDownItemsType[]
}

const filterItemBySupportChainId = (item, chainId) => {
  return !chainId || !item.supportChainIds ? true : item.supportChainIds?.includes(chainId)
}

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, isDark, languageCode, chainId) =>
    [
      {
        label: t('Trade'),
        icon: SwapIcon,
        fillIcon: SwapFillIcon,
        href: '/swap',
        showItemsOnMobile: false,
        items: [
          {
            label: t('Swap'),
            href: '/swap',
          },
          {
            label: t('Liquidity'),
            href: '/liquidity',
          },
          
        ]
      },
      {
        label: 'NFT',
        href: '#sec',
        icon: NftFillIcon,
        items: [
          {
            label: 'NFT',
            href: 'https://malirices.com/',
            type: DropdownMenuItemType.EXTERNAL_LINK,
          }
        ]
      },
      {
        label: 'Earn',
        href: '#sec',
        icon: EarnFillIcon,
        items: [
          {
            label: "CBN Staking",
            href: "https://www.ricesnetwork.com/cbnstaking",
            type: DropdownMenuItemType.EXTERNAL_LINK,
          },
          {
            label: "MALI Staking",
            href: "https://www.ricesnetwork.com/malistaking",
            type: DropdownMenuItemType.EXTERNAL_LINK,
          },
          {
            label: "BKR Staking",
            href: "https://www.ricesnetwork.com/bkrstaking",
            type: DropdownMenuItemType.EXTERNAL_LINK,
          }
        ]
      },
      {
        label: "",
        href: "#",
        icon: MoreIcon,
        items: [
          {
            label: "Rice network",
            href: "https://www.ricesnetwork.com/",
            type: DropdownMenuItemType.EXTERNAL_LINK,
          },
          {
            label: "Farmer Protocal",
            href: "https://www.farmerprotocol.com/",
            type: DropdownMenuItemType.EXTERNAL_LINK,
          }
        ],
      }
    ].filter((item) => filterItemBySupportChainId(item, chainId))

export default config
